module.exports = __webpack_public_path__ + "img/0110.e32aeca4.png";